import { useState } from "react";

import { Select } from "components/ui/Select/Select";
import { useLetterTemplates } from "features/templates/hooks/useLetterTemplates";

import styles from "./ChooseLetterTemplateModal.module.css";

export const ChooseLetterTemplateModal = ({
  onSelect,
  isDisabled,
  patientId,
  consultationId,
  refetchOnOpen = false,
}) => {
  const [selectedId, setSelectedId] = useState("");
  const { data: templates = [], isLoading, refetch } = useLetterTemplates(
    patientId,
    consultationId
  );

  const options = templates.map((template) => ({
    label: template.name,
    value: String(template.id),
  }));

  const handleChange = (value) => {
    setSelectedId(value);

    if (!value) return;

    const template = templates.find((t) => String(t.id) === value);

    if (!template) return;

    const formattedTemplate = template.template
      ? template.template.replace(/\n/g, "<br>")
      : "";

    onSelect?.(formattedTemplate, template.name);
  };

  const handleOpen = () => {
    if (refetchOnOpen) refetch();
  };

  return (
    <div className={styles.container}>
      <label className={styles.pickerLabel}>Select template</label>
      <div onMouseDown={handleOpen} onFocus={handleOpen}>
        <Select
          options={options}
          value={selectedId}
          onChange={handleChange}
          disabled={isDisabled || isLoading}
          placeholder={isLoading ? "Loading templates..." : "Select Template"}
          fullWidth
        />
      </div>
    </div>
  );
};
